import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { GetRequest } from "../../functions/ApiFunctions";

const ListSchoolPayments = () => {
    const [data, setData] = useState([]);
    const [summary, setSummary] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await GetRequest("school-payments");
            if (res) {
                setData(res.payments || []);
                setSummary(res.summary || {});
            }
        } catch (error) {
            console.error("Error fetching school payments:", error);
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: "#",
            dataIndex: "id",
            key: "id",
            width: 60,
        },
        {
            title: "Customer",
            dataIndex: "userName",
            key: "userName",
            render: (text, record) => (
                <div>
                    <strong>{text}</strong>
                    <br />
                    <small className="text-muted">{record.userEmail}</small>
                    <br />
                    <small className="text-muted">{record.userPhone}</small>
                </div>
            ),
        },
        {
            title: "Album / School",
            dataIndex: "albumName",
            key: "albumName",
            render: (text, record) => (
                <div>
                    <strong>{text}</strong>
                    <br />
                    <small className="text-muted">{record.schoolName}</small>
                </div>
            ),
        },
        {
            title: "Vendor",
            dataIndex: "vendorName",
            key: "vendorName",
            render: (text, record) => (
                <div>
                    <strong>{text}</strong>
                    <br />
                    <small className="text-muted">{record.vendorEmail}</small>
                </div>
            ),
        },
        {
            title: "Images",
            dataIndex: "totalImages",
            key: "totalImages",
            width: 80,
            render: (text) => <span className="badge bg-secondary">{text}</span>,
        },
        {
            title: "Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            width: 100,
            render: (text) => <strong className="text-success">AED {text?.toLocaleString("en-AE")}</strong>,
        },
        {
            title: "Date",
            dataIndex: "paymentDate",
            key: "paymentDate",
            width: 150,
            render: (text) => {
                if (!text) return "-";
                return new Date(text).toLocaleString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                });
            },
        },
    ];

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4>School Payments</h4>
                            <h6>View all school photo purchases</h6>
                        </div>
                    </div>
                    <div className="page-btn">
                        <button className="btn btn-primary" onClick={fetchData} disabled={loading}>
                            <i className="me-2 fa fa-refresh"></i>
                            Refresh
                        </button>
                    </div>
                </div>

                {/* Summary Cards */}
                <div className="row mb-4">
                    <div className="col-md-4">
                        <div className="card bg-primary text-white">
                            <div className="card-body text-center">
                                <h3 className="mb-1">AED {(summary.totalRevenue || 0).toLocaleString("en-AE")}</h3>
                                <small>Total Revenue</small>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card bg-success text-white">
                            <div className="card-body text-center">
                                <h3 className="mb-1">{summary.totalOrders || 0}</h3>
                                <small>Total Orders</small>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card bg-info text-white">
                            <div className="card-body text-center">
                                <h3 className="mb-1">{summary.totalImages || 0}</h3>
                                <small>Images Sold</small>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Payments Table */}
                <div className="card table-list-card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table
                                columns={columns}
                                dataSource={data}
                                rowKey="id"
                                loading={loading}
                                pagination={{
                                    pageSize: 10,
                                    showSizeChanger: true,
                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListSchoolPayments;
